import { Action } from '@ngrx/store';

export const CHECK_ACCOMMODATION_PAYMENT =
  '[Payment] Check Accommodation Payment';

export const CHECK_CONFERENCE_PAYMENT = '[Payment] Check Conference Payment';

export class CheckAccommodationPayment implements Action {
  readonly type = CHECK_ACCOMMODATION_PAYMENT;
  constructor(public payload: boolean) {}
}

export class CheckConferencePayment implements Action {
  readonly type = CHECK_CONFERENCE_PAYMENT;
  constructor(public payload: boolean) {}
}

export type paymentActions = CheckAccommodationPayment | CheckConferencePayment;



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/actions/payment.action.ts